import { render, staticRenderFns } from "./ViewReport.vue?vue&type=template&id=6c6808c0&scoped=true&"
import script from "./ViewReport.vue?vue&type=script&lang=js&"
export * from "./ViewReport.vue?vue&type=script&lang=js&"
import style0 from "./ViewReport.vue?vue&type=style&index=0&id=6c6808c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6808c0",
  null
  
)

export default component.exports